import { useSelector } from 'react-redux'
import loginSideGraphic from './images/login_side_graphic.png'
import { Link, useHistory } from 'react-router-dom'
import logoLight from './images/kiwi-full-logo.svg'
import { FormGroup, Input } from 'reactstrap'
import { useEffect, useState } from 'react'
import {
  Mail,
  Lock,
  Check,
  Circle,
  X,
  Eye,
  User,
  Flag,
  Calendar,
} from 'react-feather'
import AxiosInstance from 'utils/AxiosInstance'
import { useDispatch } from 'react-redux'
import { assignUserToCourse } from 'store/AllCourses/actions'
import { userLogin } from 'store/user/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faUser } from '@fortawesome/free-solid-svg-icons'
import countries from './countries.json'
import Select from '../Select'
import moment from 'moment'

function Signup() {
  const isAuthed = useSelector((state) => state.auth.isAuthenticated)
  const today = moment().format('YYYY-MM-DD')

  const [enrollmentSettings, setEnrollmentSettings] = useState(null)

  const [dateInputType, setDateInputType] = useState('text')

  const dispatch = useDispatch()
  const [showCountry, setShowCountry] = useState(false)
  const [showAge, setShowAge] = useState(false)
  const [canSignup, setCanSignup] = useState(true)

  const [firstName, setFirstName] = useState('')
  const [birthdate, setBirthdate] = useState(null)
  const [country, setCountry] = useState(null)
  const [lastName, setLastName] = useState('')

  const history = useHistory()

  const [email, setEmailLogin] = useState('')
  const [password, setPasswordLogin] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const publicCourseId = localStorage.getItem('public_catalog_course_id')

  const { theme } = useSelector((state) => state.themeConfig)

  const onChangeEmail = (event) => {
    setEmailLogin(event.target.value)
  }
  const onChangeFirstName = (event) => {
    setFirstName(event.target.value)
  }
  const onChangeLastName = (event) => {
    setLastName(event.target.value)
  }
  const onChangeBirthdate = (event) => {
    setBirthdate(event.target.value)
  }
  const onChangeCountry = (event) => {
    setCountry(event?.at(0)?.option)
  }
  const onChangePassword = (event) => {
    setPasswordLogin(event.target.value)
  }
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const onSignUp = (e) => {
    e.preventDefault()

    const data = {
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      selfSignIn: publicCourseId,
      birthdate,
      country: country?.name,
    }

    const loginData = { email, password }

    AxiosInstance.post('/users/self/signup', data)
      .then((res) => {
        AxiosInstance.post('/authenticate', loginData).then((res) => {
          if (res && res.token) {
            localStorage.setItem('token', res.token)
            localStorage.setItem('top_proxy', res.token)
            console.log('res.token', typeof res.token)
            dispatch(
              userLogin(() => {
                if (enrollmentSettings.enrollment_type === 2) {
                  history.push(`/public-catalog/${publicCourseId}`)
                  localStorage.removeItem('public_catalog_course_id')
                  return
                }
                if (publicCourseId) {
                  history.push(`/course/${publicCourseId}`)
                  dispatch(assignUserToCourse(publicCourseId, true))
                  localStorage.removeItem('public_catalog_course_id')
                } else {
                  history.push('/dashboard')
                }
              })
            )
          }
        })
      })
      .catch((e) => {
        console.log(e)
      })
  }

  useEffect(() => {
    AxiosInstance.get('/settings/auth').then((data) => {
      setShowCountry(data.ask_country)
      setShowAge(data.ask_age)
      setCanSignup(data.allow_signup)
    })
  }, [])

  useEffect(() => {
    if (!canSignup || isAuthed) {
      history.push('/login')
    }
  }, [canSignup, history])

  useEffect(() => {
    if (publicCourseId) {
      AxiosInstance.get(`courses/enrollment-settings/${publicCourseId}`).then(
        (data) => setEnrollmentSettings(data)
      )
    }
  }, [publicCourseId])

  return (
    <div className='modern-login'>
      <div className='underlay d-none d-xl-block'></div>
      <div className='d-flex align-items-center h-100 responsive-signup'>
        <div className='col-md-6 col-lg-7 col-xl-8 d-none d-md-block px-0 position-relative'>
          <div className='hero is-fullheight is-image'>
            <div className='hero-body ' style={{ height: '100vh' }}>
              <div className='h-100 d-flex align-items-center'>
                <div
                  style={{
                    height: '100vh',
                    width: '100vw',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  // className='col'
                >
                  <img
                    className='hero-image-blur'
                    src={
                      theme.background && theme.background.url
                        ? theme.background.url
                        : loginSideGraphic
                    }
                    alt=''
                    aria-hidden='true'
                  />
                  <img
                    className='hero-image'
                    src={
                      theme.background && theme.background.url
                        ? theme.background.url
                        : loginSideGraphic
                    }
                    alt=''
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-6  col-lg-5 col-xl-4 px-0 is-relative '>
          <a className='top-logo mt-md-5' href='/'>
            <img
              className='light-image'
              src={
                theme.loginLogo && theme.loginLogo.url
                  ? theme.loginLogo.url
                  : logoLight
              }
              alt=''
            />
            {/* <img
              className='dark-image'
              src='assets/img/logos/logo/logo-light.svg'
              alt=''
            /> */}
          </a>

          <div className='is-form mt-2 px-lg-3' style={{ paddingTop: '50px' }}>
            <div className='hero-body'>
              <div className='form-text'>
                <h2>Sign Up</h2>
              </div>

              <form
                id='login-form'
                className='login-wrapper'
                action='activity-main.html'
              >
                <div className='control has-validation'>
                  <Input
                    type='text'
                    className='input'
                    placeholder=''
                    value={firstName}
                    onChange={onChangeFirstName}
                  />
                  <small className='error-text'>This is a required field</small>
                  <div className='auth-label'>First Name</div>
                  <div className='auth-icon'>
                    <User />
                  </div>
                  <div className='validation-icon is-error'>
                    <div className='icon-wrapper'>
                      <X />
                    </div>
                  </div>
                </div>

                <div className='control has-validation'>
                  <Input
                    type='text'
                    className='input'
                    placeholder=''
                    value={lastName}
                    onChange={onChangeLastName}
                  />
                  <small className='error-text'>This is a required field</small>
                  <div className='auth-label'>Last Name</div>
                  <div className='auth-icon'>
                    <User />
                  </div>
                  <div className='validation-icon is-error'>
                    <div className='icon-wrapper'>
                      <X />
                    </div>
                  </div>
                </div>
                {showAge ? (
                  <div className='control has-validation'>
                    <Input
                      name='birthdate'
                      id='birthdate'
                      type={dateInputType}
                      onFocus={() => setDateInputType('date')}
                      max={today}
                      // value={birthdate || 'Birthdate'}
                      onChange={onChangeBirthdate}
                      style={{ height: '60px', paddingLeft: '53px' }}
                      className='mt-3 mb-0'
                    />
                    <small className='error-text'>
                      This is a required field
                    </small>
                    {dateInputType === 'text' && (
                      <div className='auth-label'>Birthdate</div>
                    )}
                    {dateInputType === 'text' && (
                      <div className='auth-icon'>
                        <Calendar />
                      </div>
                    )}
                    <div className='validation-icon is-success'>
                      <div className='icon-wrapper'>
                        <Check />
                      </div>
                    </div>
                    <div className='validation-icon is-error'>
                      <div className='icon-wrapper'>
                        <X />
                      </div>
                    </div>
                  </div>
                ) : null}
                {showCountry ? (
                  <>
                    <div className='control has-validation custom-select-wrapper'>
                      <Select
                        placeholder={
                          <>
                            <Flag style={{ color: '#283252' }} />
                            <small
                              style={{
                                marginLeft: '0.82rem',
                                color: '#283252',
                                position: 'absolute',
                                top: '-4px',
                              }}
                            >
                              Country
                            </small>
                          </>
                        }
                        options={countries}
                        selectedOptions={country}
                        onChange={onChangeCountry}
                        multi='false'
                      />
                      <small className='error-text'>
                        This is a required field
                      </small>
                      <div className='validation-icon is-success'>
                        <div className='icon-wrapper'>
                          <Check />
                        </div>
                      </div>
                      <div className='validation-icon is-error'>
                        <div className='icon-wrapper'>
                          <X />
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}

                <div className='control has-validation'>
                  <Input
                    type='text'
                    className='input'
                    placeholder=''
                    value={email}
                    onChange={onChangeEmail}
                  />
                  <small className='error-text'>This is a required field</small>
                  <div className='auth-label'>Email Address</div>
                  <div className='auth-icon'>
                    <Mail />
                  </div>
                  <div className='validation-icon is-success'>
                    <div className='icon-wrapper'>
                      <Check />
                    </div>
                  </div>
                  <div className='validation-icon is-error'>
                    <div className='icon-wrapper'>
                      <X />
                    </div>
                  </div>
                </div>
                <div className='control has-validation'>
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    className='input'
                    value={password}
                    onChange={onChangePassword}
                  />
                  <div className='auth-label'>Password</div>
                  <div className='eye' onClick={togglePasswordVisibility}>
                    <Eye />
                  </div>
                  <div className='auth-icon'>
                    <Lock />
                  </div>
                </div>

                <div className='col-12 px-0 '>
                  <div className='button-wrap text-center d-flex flex-column align-items-center justify-content-center text-center'>
                    <button
                      onClick={onSignUp}
                      id='login-submit'
                      type='submit'
                      className='btn text-white login-button blue'
                      style={{
                        backgroundColor: '#00adf2',
                      }}
                    >
                      Sign Up
                    </button>
                    <>
                      <small className='text-center justify-content-center mt-3'>
                        Already have an account?{' '}
                        <Link to='/auth/login'>Login instead</Link>
                      </small>
                    </>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <button
          onClick={() => (window.location.href = '/public-catalog')}
          className='btn btn-info link-centered d-flex align-items-center'
        >
          Public Catalog{' '}
          <FontAwesomeIcon icon={faArrowRight} className='ml-3' />
        </button>
      </div>
    </div>
  )
}

export default Signup
